// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "LeftNav-module--cds--assistive-text--d5c56";
export var cdsHideFeedback = "LeftNav-module--cds--hide-feedback--c1318";
export var cdsShowFeedback = "LeftNav-module--cds--show-feedback--7762a";
export var cdsSkeleton = "LeftNav-module--cds--skeleton--366b5";
export var cdsVisuallyHidden = "LeftNav-module--cds--visually-hidden--8258f";
export var currentItem = "LeftNav-module--current-item--9ae72";
export var divider = "LeftNav-module--divider--e308b";
export var dividerSpace = "LeftNav-module--divider-space--81b7a";
export var outboundLink = "LeftNav-module--outboundLink--4686f";
export var sideNavDark = "LeftNav-module--side-nav--dark--2ffde";
export var sideNavWhite = "LeftNav-module--side-nav--white--b3803";